import React from 'react';
import ServiceSlider from "./ServiceSlider2";
import Pricing from "./Pricing"; // adjust path if needed
import VideoReels from "./VideoReels";
import ProcessSection from "./ProcessSection";
import ContactSection from "./ContactSection";
import Footer from "./Footer"; 

const Services = () => {
  return (
    <>

      <div style={{ marginTop: "300px" }}>
      <ServiceSlider />
      </div>
      <Pricing />
      <VideoReels />
       <ProcessSection />
       <ContactSection />
       <Footer />
    </>
  );
};

export default Services;
